export interface IUILayoutState {
    mode: ViewMode;
    currentGroup: ICurrentGroup;
    currentUser: ICurrentUser;
    currentCredit: ICurrentCredit;
    cachedPath: string;
}

export interface ICurrentGroup {
    instance?: string;
}

export interface ICurrentUser {
    instance?: string;
}

export interface ICurrentCredit {
    instance?: string;
}

export enum ViewMode {
    "desktop" = "desktop",
    "tablet" = "tablet",
    "mobile" = "mobile",
}

export interface IAppState {
    ui: IUILayoutState;
}

interface IAction {
    type: string;
    payload?: any;
}

export const initialState: IAppState = {
    ui: {
        mode: ViewMode.desktop,
        currentGroup: null,
        currentUser: null,
        currentCredit: null,
        cachedPath: null,
    },
};

export const actions = {
    SET_VIEW_MODE: "SET_VIEW_MODE",
    SET_CURRENT_GROUP: "SET_CURRENT_GROUP",
    SET_CURRENT_USER: "SET_CURRENT_USER",
    SET_CURRENT_CREDIT: "SET_CURRENT_CREDIT",
    SET_CACHED_PATH: "SET_CACHED_PATH",
};

export const reducer = (state: IAppState, action: IAction) => {
    switch (action.type) {
        case actions.SET_VIEW_MODE:
            if (state.ui.mode !== action.payload) {
                return {
                    ...state,
                    ui: {
                        ...state.ui,
                        mode: action.payload,
                    },
                };
            }
            return state;
        case actions.SET_CURRENT_GROUP:
            if (state.ui.currentGroup !== action.payload) {
                return {
                    ...state,
                    ui: {
                        ...state.ui,
                        currentGroup: action.payload,
                    },
                };
            }
            return state;
        case actions.SET_CURRENT_USER:
            if (state.ui.currentUser !== action.payload) {
                return {
                    ...state,
                    ui: {
                        ...state.ui,
                        currentUser: action.payload,
                    },
                };
            }
            return state;
        case actions.SET_CURRENT_CREDIT:
            if (state.ui.currentCredit !== action.payload) {
                return {
                    ...state,
                    ui: {
                        ...state.ui,
                        currentCredit: action.payload,
                    },
                };
            }
            return state;
        case actions.SET_CACHED_PATH:
            if (state.ui.cachedPath !== action.payload) {
                return {
                    ...state,
                    ui: {
                        ...state.ui,
                        cachedPath: action.payload,
                    },
                };
            }
            return state;
        default:
            return state;
    }
};
